import { useFilterCardCategoryContext } from "./filter-card-category.context";

export function FilterCardCategory() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterCardCategoryContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}